import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Layout, Row, Col, Form, Tooltip, Popconfirm,Breadcrumb } from "antd";
import { useTranslation } from "react-i18next";
import {
  EditOutlined,
  DeleteOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { authUserData } from "../../utils/Helper";
import { getRequest, postRequest } from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import { ReactComponent as MaterialMasterIcon } from "../../image/MaterialMasterIcon.svg";
import SubscriptionNotification from "../../authentication/SubscriptionNotification";

const { Content } = Layout;

const CompanyAddressList = () => {
  const { t } = useTranslation();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [totalCount, settotalCount] = useState(0);
  const [SitelOcationlist, setSiteLocationList] = useState([]);

  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
  });
  const CompanyAddressListGetById = async () => {
    setLoading(true);

    try {
      let apiResponse = await getRequest(
        `delivery-address/${CompanyId}/get-address-by-company/`,
        state
      );
      if (apiResponse.data.results.data) {
        setSiteLocationList(apiResponse.data.results.data);
        settotalCount(apiResponse.data.count);
      } else {
        ErrorNotificationMsg(t("error_in_list_prapproval_hierarchy"));
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    CompanyAddressListGetById();
  }, [reload, state]);

  const handleArchive = async (id) => {
    try {
      let apiResponse = await postRequest("delivery-address-archive/", {
        deleted: [id],
      });
      if (apiResponse.data.success) {
        let totalArchive = totalCount - 1;

        if (totalArchive < 11) {
          setState((prevState) => ({
            ...prevState,
            page: 1,
            search: "",
          }));
          setReload(!reload);
        } else {
          setReload(!reload);
        }
        SuccessNotificationMsg(t("Site location archived successfully"));
      } else {
        if (Array.isArray(apiResponse.data.message)) {
          ErrorNotificationMsg(apiResponse.data.message.join(", "));
        } else {
          ErrorNotificationMsg(apiResponse.data.message);
        }
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        page: 1,
        search: "",
      }));
    }
  };
  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
          
            <h3>Company Site Location</h3>

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>

              <Breadcrumb.Item>Company Site Location</Breadcrumb.Item>
            </Breadcrumb>
            </div>
            <div className="pgnmbtns">
              <Tooltip placement="topLeft" title="Archived Records">
                <Link to="/delivery-address/archive" className="Archiveicon">
                  <Archiveicon />
                </Link>
              </Tooltip>
            </div>
          
        </div>
      </div>
    
          <div className="stepscontentwrap">
           {
          authUserData().company_role === "Company Admin" && authUserData().employee === null && <SubscriptionNotification />
        }
            <div className="stepsContent">
              <div className="cardswraper">
                <Row gutter={24}>
                  <Col xs={24} sm={24} md={12} xl={8} xxl={6}>
                    <div className="stepcard addsite">
                      <div>
                        <Link to="/delivery-address/add">
                          <PlusCircleOutlined />
                        </Link>
                        <h5>Add Site Location</h5>
                      </div>
                    </div>
                  </Col>
                  {SitelOcationlist.map((item, index) => (
                    <Col xs={24} sm={24} md={12} xl={8} xxl={6} key={index}>
                      <div className="stepcard sitecard">
                        <div className="cardtitle">
                          {item.company_name}
                          <div key={item.id} className="action">
                            <Tooltip
                              color={"#094E8F"}
                              placement="left"
                              title={
                                <span style={{ color: "#fff" }}>
                                  Manage Material
                                </span>
                              }
                            >
                              <Link to={`/delivery-address-material/edit/${item.id}`}>
                                <MaterialMasterIcon
                                  style={{ height: "19px", marginTop: "5px" }}
                                  
                                />{" "}
                              </Link>
                            </Tooltip>
                            <Link to={`/delivery-address/edit/${item.id}`}>
                              <EditOutlined />{" "}
                            </Link>
                            <Popconfirm
                              className="action"
                              title={t("pop_title")}
                              okText={t("pop_ok")}
                              cancelText={t("pop_cancel")}
                              onConfirm={() => handleArchive(item.id)}
                            >
                              <DeleteOutlined />
                            </Popconfirm>
                          </div>
                        </div>
                        <Row gutter={16}>
                          <Col xs={24}>
                            <Form.Item>
                              <label>Site Name </label>
                              <span className="value">{item.site_name}</span>
                            </Form.Item>
                            <Form.Item>
                              <label>Legal Name of Business </label>
                              <span className="value">
                                {item.company_legal_name}
                              </span>
                            </Form.Item>
                          </Col>
                          <Col xs={24}>
                            <Form.Item>
                              <label>GSTN </label>
                              <span className="value">{item.gst_number}</span>
                            </Form.Item>
                          </Col>
                          <Col xs={24}>
                            <Form.Item>
                              <label>Address </label>
                              <span className="value">
                                {item.shipping_address_line_1},{" "}
                                {item.shipping_city}, {item.shipping_state}
                              </span>
                            </Form.Item>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
            <div className="stepsFooter"></div>
          </div>
    
    </>
  );
};

export default CompanyAddressList;
